import { toast } from 'react-toastify';

export function Toast(type, message, ...props) {
  const toastId =
    typeof message === 'string' ? message : JSON.stringify(message); // convert html to string

  // prevent several rendering
  if (!toast.isActive(toastId)) {
    toast[type](message, { autoClose: 5000, toastId, ...props });
  }
}
